import React, { useEffect, useState } from "react";
import { PrismicRichText } from "@prismicio/react";
import { QHFacebookShareButton } from "../common/facebook-share-button";
import { QHXShareButton } from "../common/x-share-button";
import { QHLinkedinShareButton } from "../common/linkedin-share-button";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import VimeoPlayer from "../slice-components/vimeo";

export const Video = (props) => {
  const sc = props.slice.primary;
  const co = props.context.data;
  const url = "https://quantum-health.com" + props.context.url + "/";


  const getInitialState = () => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash;
      const titleMatch = hash.match(/\btitle=([^&]*)\b/);
      const contentMatch = hash.match(/\bcontent=([^&]*)\b/);
  
    return {
      pageTitle: titleMatch ? decodeURIComponent(titleMatch[1]) : sc.resource_title?.text,
      pageContent: contentMatch ? decodeURIComponent(contentMatch[1]) : sc.content?.richText,
    };
  }
  
    // Default state for SSR
    return {
      pageTitle: sc.resource_title?.text,
    };
  };
  
  // State initialization
  const [{ pageTitle, pageContent }, setPageState] = useState(getInitialState);
  
  useEffect(() => {
    const parseHashParams = () => {
      const hash = window.location.hash;
      const titleMatch = hash.match(/\btitle=([^&]*)\b/);
      const contentMatch = hash.match(/\bcontent=([^&]*)\b/);
  
      setPageState((prevState) => {
        const newTitle = titleMatch ? decodeURIComponent(titleMatch[1]) : prevState.pageTitle;
        const newContent = contentMatch ? decodeURIComponent(contentMatch[1]) : prevState.pageContent;
  
        // Update only if values have changed
        if (newTitle !== prevState.pageTitle || newContent !== prevState.pageContent) {
          document.title = newTitle; // Update page title if necessary
          return { pageTitle: newTitle, pageContent: newContent };
        }
  
        return prevState; // No state update if nothing changed
      });
    };
  
    window.addEventListener("hashchange", parseHashParams);
  
    return () => {
      window.removeEventListener("hashchange", parseHashParams);
    };
  }, []);

  return (
    <>
      <section className="video-res center relative gutter sm !pb-36 bg-gradient-to-t from-grey-light to-white">
        <div className="banner wrapper flex flex-col justify-between items-center">
          <div className="w-full md:w-4/5 m-auto text-grey text-left md:text-center icon">
            
            {/* If the content is plain text (e.g., from URL hash), render as text */}
            <h1>
                {co.resource_label && (
                <div className={"label bg-opacity-10 uppercase tracking-widest text-xs mb-1 md:mb-2 font-sans font-bold text-" + sc.theme}>{co.resource_label}&nbsp;</div>
              )}
                {pageTitle || co.resource_title.text}
            </h1>
            {sc.subtitle?.text && (
              <div className={"font-normal text-xl text-" + sc.theme}>
                {sc.subtitle.text}
              </div>
            )}
            <div className="soci md:justify-center md:mb-12">
              <p>SHARE</p>
              <QHFacebookShareButton url={url} />
              <QHXShareButton url={url} />
              <QHLinkedinShareButton url={url} />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="wrapper md:well gutter top">
          <div className="video-wrapper video-resource">
            <VimeoPlayer videoId={sc.video} />
          </div>
          <div className="gutter article bot sm w-full md:w-3/4 m-auto">
            
            {/* If the content is plain text (e.g., from URL hash), render as text */}
            {typeof pageContent === "string" ? (
              <p>{pageContent}</p>  // Render plain content
            ) : (
              <PrismicRichText field={pageContent || sc.content.richText} />  // Render rich text content
            )}
            
            {props.slice.items.some((spe) => spe.speaker_name) && (
              <>
                <h2 className="text-center text-teal-dark pt-12">Panelists</h2>
                <div className="flex flex-wrap gap-4">
                  {props.slice.items.map((spe, index) => {
                    const hasSpeakerData = spe.speaker_name && spe.speaker_image;
                    if (!hasSpeakerData) return null;

                    return (
                      <div
                        key={index}
                        className="w-full md:basis-1/2-gap-8 gap-4 flex items-center mb-4"
                      >
                        <div className="w-1/5 md:w-1/3">
                          <GatsbyImage
                            className="rounded-full"
                            image={getImage(spe.speaker_image)}
                            alt={spe.speaker_name + " photo"}
                          />
                        </div>
                        <div className="w-3/5">
                          <div className="text-lg font-bold">
                            {spe.speaker_name}
                          </div>
                          {spe.speaker_title && (
                            <div className="text-sm">
                              {spe.speaker_title}
                              <br />
                              {spe.speaker_company && (
                                <span className="text-vs font-bold uppercase text-accessible-green">
                                  {spe.speaker_company}
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};
